import { getEventPartnershipOffer } from "@/lib/event-partnerships/catalog"
import { PARTNER_AGENT_PARAM } from "@/lib/partners/constants"
import { getForcedSellerReferralCodeForSlug } from "@/lib/partners/forced-seller"
import { getPartnerPublicPath } from "@/lib/partners/partner-path"
import { SELLER_REFERRAL_PARAM } from "@/lib/seller-referral/constants"

export function buildPartnerCadastroHref(slug: string, agentCode?: string | null): string {
  const params = new URLSearchParams({ partner: slug })
  if (agentCode) {
    params.set(PARTNER_AGENT_PARAM, agentCode)
  } else {
    const forcedSeller = getForcedSellerReferralCodeForSlug(slug)
    if (forcedSeller) params.set(SELLER_REFERRAL_PARAM, forcedSeller)
  }

  const eventOffer = getEventPartnershipOffer(slug)
  if (eventOffer) {
    params.set("utm_campaign", eventOffer.utmCampaign)
    params.set("utm_content", "lp-cta")
  }

  return `/cadastro?${params.toString()}`
}

export function buildPartnerAgentShareUrl(siteOrigin: string, slug: string, code: string): string {
  const base = siteOrigin.replace(/\/$/, "")
  return `${base}${getPartnerPublicPath(slug)}?${PARTNER_AGENT_PARAM}=${encodeURIComponent(code)}`
}
